import HttpClient from "../http/http_client";

export const getAllSettingRequest = async () => {
    try {
        const response = await HttpClient.get('settings/');
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}